<h1 mat-dialog-title>{{data.title}}</h1>

<mat-dialog-content>
    @for (m of data.messages; track $index) {
        <p class="message">{{m}}</p>
    }

    @if (data.includeNotes) {
        <mat-form-field class="full">
            <mat-label>Notes (optional)</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="8" placeholder="Anything to include with the request"
                [formControl]="notesControl" [maxlength]="CONFIRM_NOTES_MAX" id="confirm-notes"></textarea>
            <mat-hint align="end">{{notesControl.value.length}}/{{CONFIRM_NOTES_MAX}}</mat-hint>
        </mat-form-field>
    }
    @if (needsConfirmText) {
        <p class="confirm-prompt">To confirm, type <strong>{{data.confirmText}}</strong> below.</p>
        <mat-form-field class="full">
            <mat-label>Type {{data.confirmText}}</mat-label>
            <input type="text" matInput [formControl]="confirmTextControl" id="confirm-text" autocomplete="off" cdkFocusInitial
                (keydown.enter)="onConfirmTextEnter($event)">
        </mat-form-field>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (data.noText) {
        <button mat-button (click)="dialogRef.close()">{{data.noText}}</button>
    }
    @if (data.secondaryButton) {
        <button mat-stroked-button [color]="isDestructive(data.secondaryButton) ? 'warn' : 'accent'" (click)="onConfirm(data.secondaryButton)" [disabled]="confirmDisabled()">{{data.secondaryButton}}</button>
    }
    <button mat-flat-button [color]="isDestructive(data.yesText) ? 'warn' : 'accent'" (click)="onConfirm(data.yesText)" [disabled]="confirmDisabled()">{{data.yesText}}</button>
</mat-dialog-actions>
